/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetInqueryOptions Input Action
 */
export class GetInqueryOptionsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    constructor(token: string| undefined) {
        this.token = token;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZFCONTACTUSINQUERYOPTIONS`;
    public getCacheObjectType = () => 'SZFCONTACTUSINQUERYOPTIONS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetInqueryOptionsData {
    status: boolean,
    data: any[] | undefined,
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInqueryOptionInput = (args: Msdyn365.ICreateActionContext,token:string): Msdyn365.IActionInput => {
    return new GetInqueryOptionsInput(token);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getInqueryOptionsDataAction(input: GetInqueryOptionsInput, ctx: Msdyn365.IActionContext): Promise<IGetInqueryOptionsData> {
    const token = input.token;
    const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomain}/api/data/v9.2//szf_casetypes?$select=szf_name,szf_arabic`, "get", {}, {
        headers: {
            'Authorization':`Bearer ${token}`
        }
    });
    if(response && response.data && response.data.value && response.data.value.length > 0){
        return {
            status: true,
            data: response.data.value
        };
    }else{
        return {
            status: false,
            data: undefined
        };
    }

    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetInqueryOptionsData[]>('/get/example/id/1', 'get');
    // return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetInqueryOptionsData>>getInqueryOptionsDataAction,
    // TODO: Give your data action a unique id
    id: 'GetInqueryOptions',
    input: createInqueryOptionInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
